import { makeStyles } from "@material-ui/core/styles";
import { DeliveryTypeEnum as DelEnum } from "@saleor/types/globalTypes";
import classNames from "classnames";
import React from "react";

export interface OrderDeliveryTypeProps {
  delType: DelEnum | null;
}

const useStyles = makeStyles(
  {
    delTypeExpress: {
      backgroundColor: "#F1996F"
    },
    delTypeExpressLong: {
      backgroundColor: "#E3167D"
    },
    delTypeInMall: {
      backgroundColor: "#1D57A5"
    },
    delTypeNationwide: {
      backgroundColor: "#EAE6FF",
      color: "#403294 !important"
    },
    delTypeNextDay: {
      backgroundColor: "#6DAB64"
    },
    delTypeSameDay: {
      backgroundColor: "#6051E3"
    },
    deliveryHolder: {
      color: "#ffffff",
      padding: "5px"
    }
  },
  { name: "OrderDeliveryType" }
);

const OrderDeliveryType: React.FC<OrderDeliveryTypeProps> = props => {
  const { delType } = props;
  const classes = useStyles(props);

  let newLabel = "";
  let newStyle = "";

  if (delType === DelEnum.EXPRESS) {
    newLabel = "Express Delivery";
    newStyle = classes.delTypeExpress;
  } else if (delType === DelEnum.IN_STORE_PICKUP) {
    newLabel = "In-Store Pick Up";
    newStyle = classes.delTypeInMall;
  } else if (delType === DelEnum.NEXT_DAY) {
    newLabel = "Standard Delivery";
    newStyle = classes.delTypeNextDay;
  } else if (delType === DelEnum.SAME_DAY) {
    newLabel = "Same Day Delivery";
    newStyle = classes.delTypeSameDay;
  } else if (delType === DelEnum.EXPRESS_LONG_DISTANCE) {
    newLabel = "10km Express Delivery";
    newStyle = classes.delTypeExpressLong;
  } else if (delType === DelEnum.NATIONWIDE_DELIVERY) {
    newLabel = "Nationwide Delivery";
    newStyle = classes.delTypeNationwide;
  }

  return (
    <>
      <span className={classNames(newStyle, classes.deliveryHolder)}>
        {newLabel}
      </span>
    </>
  );
};

export default OrderDeliveryType;
